import { CrmSegmentItemResponse } from '../generated';
import { testCrmMarketResponse } from './crmMarketResponse';

export const testCrmSegmentItemResponse: CrmSegmentItemResponse = {
  code: 'Test Segment Code',
  name: 'Test Segment Name',
  markets: [testCrmMarketResponse],
};
